__turbopack_context__.v({
  "content": "index-module__vI2BKq__content",
  "description": "index-module__vI2BKq__description",
});
